// extracted by mini-css-extract-plugin
export default {"container":"Kaa-z","oos":"Laa-z","oosUx":"Maa-z","selected":"Naa-z","labelOos":"Oaa-z"};